  <!-- Add Address Dialog -->
  <p-dialog [(visible)]="displayAddAddressDialog" (visibleChange)="displayAddAddressDialogChange.emit($event)" 
            header="Add New Address" [modal]="true" [style]="{width: '700px'}"
            styleClass="address-dialog" [draggable]="false">
    <div class="flex flex-column gap-3">
      <!-- Customer Info Display -->
      <div class="surface-section p-3 border-round-lg shadow-1" 
           style="background-color: var(--surface-100);">
        <div class="flex align-items-center gap-2">
          <i class="pi pi-user text-primary"></i>
          <span class="font-medium">Adding address for: <strong>{{selectedCustomer.name}}</strong></span>
        </div>
      </div>

      <!-- Address Information Section -->
      <div class="surface-section p-3 border-round-lg shadow-1" 
           style="background-color: var(--surface-card);">
        <div class="text-lg font-semibold text-900 mb-3">
          <i class="pi pi-map-marker mr-2"></i>
          Address Information
        </div>
        <div class="flex flex-column gap-3">
          <span class="p-float-label w-full">
            <textarea pInputTextarea id="new-address" [(ngModel)]="newAddress.address" [rows]="2"
              class="w-full"></textarea>
            <label for="new-address">Street Address</label>
          </span>
          <div class="flex gap-3">
            <span class="p-float-label flex-1">
              <input pInputText id="new-city" [(ngModel)]="newAddress.city" class="w-full" />
              <label for="new-city">City</label>
            </span>
            <span class="p-float-label" style="width: 120px;">
              <input pInputText id="new-state" [(ngModel)]="newAddress.state" class="w-full" />
              <label for="new-state">State</label>
            </span>
            <span class="p-float-label" style="width: 120px;">
              <input pInputText id="new-zip" [(ngModel)]="newAddress.zipcode" class="w-full" />
              <label for="new-zip">ZIP</label>
            </span>
          </div>
          <span class="p-float-label w-full">
            <textarea pInputTextarea id="new-address-notes" [(ngModel)]="newAddress.notes" [rows]="2"
              class="w-full"></textarea>
            <label for="new-address-notes">Address Notes</label>
          </span>
        </div>
      </div>

      <!-- Service Hours Section -->
      <div class="surface-section p-3 border-round-lg shadow-1" 
           style="background-color: var(--surface-card);">
        <div class="text-lg font-semibold text-900 mb-3">
          <i class="pi pi-clock mr-2"></i>
          Service Hours
        </div>
        <div class="flex gap-3">
          <div class="flex-1">
            <label for="new_service_hours_start" class="block text-sm font-medium mb-2">Start Time</label>
            <input type="time" pInputText id="new_service_hours_start" [(ngModel)]="newAddress.service_hours_start" class="w-full" />
          </div>
          <div class="flex-1">
            <label for="new_service_hours_end" class="block text-sm font-medium mb-2">End Time</label>
            <input type="time" pInputText id="new_service_hours_end" [(ngModel)]="newAddress.service_hours_end" class="w-full" />
          </div>
        </div>
      </div>

      <!-- Contacts Section -->
      <div class="surface-section p-3 border-round-lg shadow-1" 
           style="background-color: var(--surface-card);">
        <div class="text-lg font-semibold text-900 mb-3">
          <i class="pi pi-users mr-2"></i>
          Contacts for this Address
        </div>
        <div class="flex flex-column gap-3">
          <!-- Show existing contacts -->
          <div *ngFor="let contact of newAddress.contacts; let i = index" 
               class="p-2 border-1 border-200 border-round">
                      <div class="flex align-items-center gap-2 mb-2">
            <span class="font-medium text-sm">Contact {{i + 1}}</span>
            <div class="flex-1"></div>
              <button pButton 
                      type="button" 
                      icon="pi pi-trash" 
                      (click)="removeNewAddressContact(i)"
                      class="p-button-rounded p-button-text p-button-sm p-button-danger"
                      [style]="{'width': '24px', 'height': '24px'}"
                      *ngIf="newAddress.contacts.length > 1">
              </button>
            </div>
            
            <div class="flex gap-2">
              <span class="p-float-label flex-1">
                <input pInputText 
                       id="new_contact_name_{{i}}" 
                       [(ngModel)]="contact.name" 
                       class="w-full" />
                <label for="new_contact_name_{{i}}">Name</label>
              </span>
              <span class="p-float-label flex-1">
                <input pInputText 
                       id="new_contact_email_{{i}}" 
                       [(ngModel)]="contact.email" 
                       type="email"
                       class="w-full" />
                <label for="new_contact_email_{{i}}">Email</label>
              </span>
              <span class="p-float-label flex-1">
                <input pInputText 
                       id="new_contact_phone_{{i}}" 
                       [(ngModel)]="contact.phone" 
                       class="w-full" />
                <label for="new_contact_phone_{{i}}">Phone</label>
              </span>
            </div>
          </div>

          <!-- Show message when no contacts -->
          <div *ngIf="!newAddress.contacts || newAddress.contacts.length === 0" 
               class="text-center text-500 py-4">
            <i class="pi pi-info-circle mr-2"></i>
            No contacts added yet
          </div>
          
          <!-- Add New Contact Button -->
          <div class="flex justify-content-center pt-2">
            <button pButton 
                    label="Add Contact" 
                    icon="pi pi-plus" 
                    (click)="addNewAddressContact()" 
                    class="p-button-outlined p-button-sm"></button>
          </div>
        </div>
      </div>
    </div>

    <ng-template pTemplate="footer">
      <div class="flex justify-content-end gap-2">
        <button pButton label="Cancel" (click)="cancelAddAddress()" class="p-button-outlined"></button>
        <button pButton label="Add Address" icon="pi pi-check" (click)="saveNewAddress()"
          [disabled]="!newAddress.address || !newAddress.city"></button>
      </div>
    </ng-template>
  </p-dialog>

